function consoleFnForLevel(level: string): (...args: unknown[]) => void {
  switch (level.toLowerCase()) {
    case 'error':
      return console.error.bind(console);
    case 'warn':
      return console.warn.bind(console);
    case 'log':
      return console.log.bind(console);
    default:
      return console.info.bind(console);
  }
}

export function runPrintImplementation(data: { message?: string; level?: string }) {
  const message = String(data.message ?? '');
  const level = String(data.level ?? 'info');
  consoleFnForLevel(level)(`[graph] ${message}`);
}

export function runPrintVarImplementation(data: { label?: string; value?: unknown }) {
  const label = String(data.label ?? 'value');
  console.info(`[graph] ${label}:`, data.value);
}
